import { render, staticRenderFns } from "./buy-isp-proxy-view.vue?vue&type=template&id=f6d565ac&scoped=true"
import script from "./buy-isp-proxy-view.vue?vue&type=script&lang=js"
export * from "./buy-isp-proxy-view.vue?vue&type=script&lang=js"
import style0 from "./buy-isp-proxy-view.vue?vue&type=style&index=0&id=f6d565ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d565ac",
  null
  
)

export default component.exports